<template>
  <div>
    <CookieConsent/>
    <router-view />
  </div>
</template>

<script setup>
import { ref, reactive} from "vue";
import CookieConsent from "@/components/cookies-consent/cookies-consent.vue"
</script>
